import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const Container = styled.span`
    color: ${tokens.text.secondary};
`;

export function NoValue() {
    return <Container>--</Container>;
}
